"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var alpinejs_1 = require("alpinejs");
var collapse_1 = require("@alpinejs/collapse");
var focus_1 = require("@alpinejs/focus");
var gsap_1 = require("./gsap");
var js_api_loader_1 = require("@googlemaps/js-api-loader");
var types_1 = require("../../../components/types");
// Ensure the dataLayer is always globally present.
window.dataLayer = window.dataLayer || [];
// Expose the Alpine object globally so that we can register modules as separate JS files.
window.Alpine = alpinejs_1.default;
// Register Alpine plugins.
alpinejs_1.default.plugin(collapse_1.default);
alpinejs_1.default.plugin(focus_1.default);
// Google Maps APK Key and Map ID - created on Baptcare's account.
var GOOGLE_MAPS_API_KEY = 'AIzaSyCVXRUAqLTSLSV4FDb93L27XGw3BL4VmAo';
var MAP_ID = '2bf73e0991e63348';
var googleLoader = new js_api_loader_1.Loader({
    apiKey: GOOGLE_MAPS_API_KEY,
});
// Register the Alpine store for this project.
document.addEventListener('alpine:init', function () {
    alpinejs_1.default.store('app', {
        sm: false,
        md: false,
        lg: false,
        xl: false,
        showHeader: true,
        scrollDirection: '', // Values: up or down.
        init: function () {
            this.detectBreakpoints();
            this.detectScrollDirection();
            this.initAutoScroll();
        },
        detectBreakpoints: function () {
            var _this = this;
            var root = getComputedStyle(document.querySelector(':root'));
            // Breakpoints have been exposed as CSS Variables by `global.scss`.
            var screens = {
                sm: root.getPropertyValue('--breakpoint-sm'),
                md: root.getPropertyValue('--breakpoint-md'),
                lg: root.getPropertyValue('--breakpoint-lg'),
                xl: root.getPropertyValue('--breakpoint-xl'),
            };
            var smQ = window.matchMedia("(min-width: ".concat(screens.sm, ")"));
            var mdQ = window.matchMedia("(min-width: ".concat(screens.md, ")"));
            var lgQ = window.matchMedia("(min-width: ".concat(screens.lg, ")"));
            var xlQ = window.matchMedia("(min-width: ".concat(screens.xl, ")"));
            // Run on page load to get initial values.
            this.sm = smQ.matches;
            this.md = mdQ.matches;
            this.lg = lgQ.matches;
            this.xl = xlQ.matches;
            // Listen for changes.
            smQ.addEventListener('change', function (_a) {
                var matches = _a.matches;
                return (_this.sm = matches);
            });
            mdQ.addEventListener('change', function (_a) {
                var matches = _a.matches;
                return (_this.md = matches);
            });
            lgQ.addEventListener('change', function (_a) {
                var matches = _a.matches;
                return (_this.lg = matches);
            });
            xlQ.addEventListener('change', function (_a) {
                var matches = _a.matches;
                return (_this.xl = matches);
            });
        },
        detectScrollDirection: function () {
            var _this = this;
            var scrollPos = 0;
            var timeout;
            window.addEventListener('scroll', function () {
                clearTimeout(timeout);
                var top = document.body.getBoundingClientRect().top;
                if (top > scrollPos) {
                    timeout = setTimeout(function () {
                        if (_this.scrollDirection !== 'up') {
                            _this.scrollDirection = 'up';
                        }
                    }, 50);
                }
                else {
                    timeout = setTimeout(function () {
                        if (_this.scrollDirection !== 'down') {
                            _this.scrollDirection = 'down';
                        }
                    }, 50);
                }
                scrollPos = top;
                // Determine whether or not the header should be hidden or shown.
                if (_this.scrollDirection === 'up') {
                    _this.showHeader = true;
                }
                else {
                    _this.showHeader = Math.abs(top) < 150;
                }
            });
        },
        api: function (route_1, data_1) {
            return __awaiter(this, arguments, void 0, function (route, data, method) {
                var endpoint, response;
                if (method === void 0) { method = 'post'; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            endpoint = '/wp-json/rest/v1';
                            return [4 /*yield*/, fetch("".concat(endpoint, "/").concat(route), {
                                    method: method,
                                    headers: {
                                        Accept: 'application/json',
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify(data),
                                })];
                        case 1:
                            response = _a.sent();
                            return [4 /*yield*/, response.json()];
                        case 2: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        track: function (data) {
            window.dataLayer.push(data);
        },
        initAutoScroll: function () {
            var _this = this;
            var anchorLinks = Array.from(document.querySelectorAll('a[href^="#"]'));
            if (anchorLinks.length) {
                anchorLinks.forEach(function (link) {
                    link.addEventListener('click', function (event) {
                        event.preventDefault();
                        var id = link.getAttribute('href');
                        var el = document.querySelector(id);
                        if (el) {
                            _this.scrollTo(el);
                        }
                    });
                });
            }
        },
        scrollTo: function (el, offset) {
            (0, gsap_1.scrollTo)(el, offset);
        },
        redirectSelect: function (el) {
            var value = el.value || '';
            if (value) {
                window.location.href = value;
            }
        },
        loadGoogleMaps: function () {
            return __awaiter(this, void 0, void 0, function () {
                var AdvancedMarkerElement, Map, pinSvg, MarkerIcon;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, googleLoader.importLibrary('marker')];
                        case 1:
                            AdvancedMarkerElement = (_a.sent()).AdvancedMarkerElement;
                            return [4 /*yield*/, googleLoader.importLibrary('maps')];
                        case 2:
                            Map = (_a.sent()).Map;
                            pinSvg = "<svg width=\"24\" height=\"30\" viewBox=\"0 0 24 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.8872 29.7098L12.889 29.7085L12.8917 29.7065L12.9001 29.7004L12.9279 29.6797C12.9513 29.6622 12.9845 29.6372 13.0267 29.6051C13.1111 29.5408 13.2318 29.4477 13.3835 29.3273C13.6869 29.0867 14.1154 28.7364 14.6273 28.2894C15.649 27.3973 17.014 26.1107 18.3831 24.5329C21.0718 21.4344 24.0002 16.958 24.0002 12.0001C24.0002 5.37263 18.6276 0 12.0001 0C5.37263 0 0 5.37263 0 12.0001C0 16.958 2.92841 21.4344 5.61712 24.5329C6.98623 26.1107 8.35118 27.3973 9.37292 28.2894C9.88484 28.7364 10.3133 29.0867 10.6167 29.3273C10.7685 29.4477 10.8891 29.5408 10.9735 29.6051C11.0157 29.6372 11.0489 29.6622 11.0723 29.6797L11.1002 29.7004L11.1085 29.7065L11.1122 29.7093C11.6402 30.0965 12.3592 30.0971 12.8872 29.7098ZM11.9968 15.7501C14.0679 15.7501 15.7469 14.0712 15.7469 12.0001C15.7469 9.92903 14.0679 8.25008 11.9968 8.25008C9.92573 8.25008 8.24678 9.92903 8.24678 12.0001C8.24678 14.0712 9.92573 15.7501 11.9968 15.7501Z\" fill=\"#003640\"/></svg>";
                            MarkerIcon = new DOMParser().parseFromString(pinSvg, 'image/svg+xml').documentElement;
                            return [2 /*return*/, {
                                    MAP_ID: MAP_ID,
                                    MarkerIcon: MarkerIcon,
                                    AdvancedMarkerElement: AdvancedMarkerElement,
                                    Map: Map,
                                }];
                    }
                });
            });
        },
        loadGooglePlaces: function () {
            return __awaiter(this, void 0, void 0, function () {
                var Autocomplete;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, googleLoader.importLibrary('places')];
                        case 1:
                            Autocomplete = (_a.sent()).Autocomplete;
                            return [2 /*return*/, {
                                    Autocomplete: Autocomplete,
                                }];
                    }
                });
            });
        },
        loadTurnstile: function (id, action, callback) {
            var scriptEl = document.createElement('script');
            scriptEl.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
            scriptEl.onload = function () {
                var turnstileID = window.turnstile.render(id, {
                    sitekey: '0x4AAAAAAAchBgPWx3kUJgjn',
                    appearance: 'interaction-only',
                    action: action,
                    theme: 'light',
                    callback: function (token) {
                        callback(token, types_1.TurnstileMethods.HAS_TOKEN);
                        // Got the token, remove the Turnstile widget.
                        window.turnstile.remove(turnstileID);
                    },
                    'error-callback': function () {
                        var x = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            x[_i] = arguments[_i];
                        }
                        callback('', types_1.TurnstileMethods.ERROR);
                    },
                    'before-interactive-callback': function () {
                        callback('', types_1.TurnstileMethods.BEFORE_INTERACTIVE);
                    },
                    'after-interactive-callback': function () {
                        callback('', types_1.TurnstileMethods.AFTER_INTERACTIVE);
                    },
                });
            };
            document.head.append(scriptEl);
        },
        generateSpeculationRules: function () {
            var specRules = {
                prerender: [
                    // {
                    //   urls: ['/', '/news'],
                    // },
                    {
                        where: {
                            href_matches: '/*',
                        },
                        eagerness: 'moderate', // start pre-rendering on hover after 200ms.
                    },
                ],
            };
            var scriptEl = document.createElement('script');
            scriptEl.type = 'speculationrules';
            scriptEl.textContent = JSON.stringify(specRules);
            document.body.append(scriptEl);
        },
    });
    /* -----------------------------------------------------------------------------------
    Set up an AlpineJS Directive to handle tracking.
    Usage: <div x-data x-track.<modifier>="<module-name>">
    <modifier>:
      links: will track clicks against <a> tags.
      visibility: will track entry of modules into viewport.
      carousel: will track clicks on Carousel controls.
  
    Modifiers can be stacked, e.g.
    Usage: <div x-data x-track.links.carousel="<module-name>">
    ----------------------------------------------------------------------------------- */
    alpinejs_1.default.directive('track', function (el, _a) {
        var expression = _a.expression, modifiers = _a.modifiers;
        if (!modifiers.length)
            return;
        var initialiseModifierFeatures = function () {
            if (modifiers.includes('links')) {
                var links = Array.from(el.querySelectorAll('a'));
                links.forEach(function (link) {
                    link.addEventListener('click', function () {
                        alpinejs_1.default.store('app').track({
                            event: "click_".concat(expression),
                            type: 'click',
                            module: expression,
                            data: {
                                title: link.textContent.trim(),
                                url: link.href,
                                target: link.target || '',
                                id: link.getAttribute('id') || '',
                            },
                        });
                    });
                });
            }
            if (modifiers.includes('visibility')) {
                (0, gsap_1.trackVisibility)(el, function () {
                    alpinejs_1.default.store('app').track({
                        event: 'visibility',
                        type: 'enter',
                        module: expression,
                        data: {},
                    });
                });
            }
            if (modifiers.includes('carousel')) {
                var leftArrow = el.querySelector('[data-track-prev-slide]');
                var rightArrow = el.querySelector('[data-track-next-slide]');
                var bullets = Array.from(el.querySelectorAll('[data-track-pagination]'));
                var thumbs = Array.from(el.querySelectorAll('[data-track-thumbs] .swiper-slide'));
                // Track left and right arrows.
                leftArrow &&
                    leftArrow.addEventListener('click', function () {
                        alpinejs_1.default.store('app').track({
                            event: 'click_carousel',
                            type: 'click',
                            trigger: 'prev-slide',
                            module: expression,
                            data: {},
                        });
                    });
                rightArrow &&
                    rightArrow.addEventListener('click', function () {
                        alpinejs_1.default.store('app').track({
                            event: 'click_carousel',
                            type: 'click',
                            trigger: 'next-slide',
                            module: expression,
                            data: {},
                        });
                    });
                // Track pagination bullets.
                bullets.length &&
                    bullets.forEach(function (bullet) {
                        bullet.addEventListener('click', function () {
                            alpinejs_1.default.store('app').track({
                                event: 'click_carousel',
                                type: 'click',
                                trigger: 'bullet',
                                module: expression,
                                data: {},
                            });
                        });
                    });
                // Track thumbnails
                thumbs.length &&
                    thumbs.forEach(function (thumb) {
                        thumb.addEventListener('click', function () {
                            alpinejs_1.default.store('app').track({
                                event: 'click_carousel',
                                type: 'click',
                                trigger: 'thumb',
                                module: expression,
                                data: {
                                    slide_number: thumb.getAttribute('data-swiper-slide-index') || null,
                                },
                            });
                        });
                    });
            }
        };
        // Give it 1 second before initialising the tracking code.
        // This will allow some modules which use `<template x-if="condition">...</template>` to have time to run the script.
        setTimeout(initialiseModifierFeatures, 1000);
    });
});
var alpineTimeout;
var alpineDelay = 1000;
/**
 * Initialise AlpineJS when the DOM is ready.
 *
 * NOTE: Within Storybook, we have to delay the initialisation of Alpine as Storybook seems to trigger
 * the DOMContentLoaded event twice, which throws a few errors
 */
document.addEventListener('DOMContentLoaded', function () {
    if (window.IS_STORYBOOK) {
        clearTimeout(alpineTimeout);
        alpineTimeout = setTimeout(function () {
            console.info('%cDelaying initialisation of AlpineJS within Storybook. Read more: src/js/libraries/alpine.ts', 'color:skyblue');
            alpinejs_1.default.start();
        }, alpineDelay);
    }
    else {
        alpinejs_1.default.start();
    }
});
